module.exports = __webpack_public_path__ + "static/media/Ute.5dd3dc4c.png";